export default {
  "stepper-wrapper_title_step-1": "Step 1",
  "stepper-wrapper_title_step-2": "Step 2",
  "stepper-wrapper_title_step-3": "Step 3"
};